import type { DesignFontSummary } from '../../services/designApi'

const loaded = new Set<string>()
/** Erfolgreich geladene Schnitte (für das Einbetten in Snapshots, siehe design/snapshot.ts). */
const loadedSources = new Map<string, { family: string; weight: number; italic: boolean; url: string }>()
export function loadedFontSources() { return [...loadedSources.values()] }

/** Lädt nur die tatsächlich benötigten Schnitte per FontFace API (identische WOFF2 wie im Druck). */
export async function ensureFontsLoaded(fonts: DesignFontSummary[], familyIds: Iterable<string>): Promise<void> {
  if (typeof document === 'undefined' || !('fonts' in document)) return
  const wanted = new Set(familyIds)
  const jobs: Promise<unknown>[] = []
  for (const family of fonts) {
    if (!wanted.has(family.id)) continue
    for (const face of family.faces) {
      const key = `${family.id}:${face.weight}:${face.italic ? 'i' : 'n'}`
      if (loaded.has(key)) continue
      loaded.add(key)
      try {
        const ff = new FontFace(family.family, `url("${face.woff2Url}") format("woff2")`, { weight: String(face.weight), style: face.italic ? 'italic' : 'normal', display: 'block' })
        jobs.push(ff.load().then((f) => {
          (document as any).fonts.add(f)
          loadedSources.set(key, { family: family.family, weight: Number(face.weight) || 400, italic: !!face.italic, url: face.woff2Url })
        }).catch(() => { loaded.delete(key) }))
      } catch {
        loaded.delete(key)
      }
    }
  }
  await Promise.all(jobs)
  try { await (document as any).fonts.ready } catch {}
}
